import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import isSameDay from 'date-fns/isSameDay';
import parse from 'date-fns/parse';
import lscache from 'lscache';

import { getTimeDifference } from './convertTime';

export function getExperienceTimezoneOffsetFromMemory(
  experienceId: string,
): string {
  try {
    const fromCache = lscache.get('experienceTimezoneOffsets') || {};
    const experienceTimezoneOffsets = JSON.parse(fromCache);
    return experienceTimezoneOffsets[experienceId];
  } catch (e) {
    return '';
  }
}

export function isInSameDay(
  time: string,
  fromOffset: string,
  toOffset: string,
): boolean {
  const { hoursDifference, minutesDifference } = getTimeDifference(
    fromOffset,
    toOffset,
  );
  const [hours, minutes] = time.split(':');

  const originalDateTime = parse(
    '1970-01-01T00:00',
    "yyyy-MM-dd'T'HH:mm",
    new Date(),
  );
  const original = addMinutes(
    addHours(originalDateTime, parseInt(hours, 10)),
    parseInt(minutes, 10),
  );
  const compare = addMinutes(
    addHours(original, hoursDifference),
    minutesDifference,
  );

  return isSameDay(compare, original);
}

export function isTimezoneOffsetInPast(
  fromOffset: string,
  toOffset: string,
): boolean {
  const { hoursDifference, minutesDifference } = getTimeDifference(
    fromOffset,
    toOffset,
  );
  return (
    hoursDifference > 0 || (hoursDifference === 0 && minutesDifference > 0)
  );
}

export function isTimezoneOffsetInFuture(
  fromOffset: string,
  toOffset: string,
): boolean {
  const { hoursDifference, minutesDifference } = getTimeDifference(
    fromOffset,
    toOffset,
  );
  return (
    hoursDifference < 0 || (hoursDifference === 0 && minutesDifference < 0)
  );
}

export function convertDate(
  date: Date,
  fromOffset: string,
  toOffset: string,
): Date {
  const { hoursDifference, minutesDifference } = getTimeDifference(
    fromOffset,
    toOffset,
  );

  return addHours(addMinutes(date, minutesDifference), hoursDifference);
}
